import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useAtom } from 'jotai';
import { useShowSummaryV2 } from '../useShowSummaryV2';
import { OwnershipTimelineViewMode, ownershipTimelineViewModeJ } from './viewMode';

interface IViewModeToggleProps {
  companyId: number;
}

export function ViewModeToggle({ companyId }: IViewModeToggleProps) {
  const showSummaryV2 = useShowSummaryV2();
  const [mode, setMode] = useAtom(ownershipTimelineViewModeJ(companyId));

  return (
    <ToggleButtonGroup
      aria-label='ownership timeline view mode'
      color='primary'
      exclusive
      size='small'
      value={mode}
      onChange={(_, next: OwnershipTimelineViewMode | null) => {
        if (next !== null) {
          setMode(next);
        }
      }}
    >
      <ToggleButton value='ownership' aria-label='ownership percent'>
        Ownership %
      </ToggleButton>
      <ToggleButton value='shares' aria-label='shares'>
        Shares
      </ToggleButton>
      {showSummaryV2 && (
        <ToggleButton value='value' aria-label='value'>
          Value
        </ToggleButton>
      )}
    </ToggleButtonGroup>
  );
}
